import { Stack, Typography } from '@mui/material';
import { TypographyProps } from '@mui/material';
import { SxProps } from '@mui/system';
import { useIsDesktop } from 'Hooks';
import { ReactNode, useCallback } from 'react';

interface ITypography {
  text: string;
  typographyStyles?: Partial<TypographyProps>;
}

interface IStackWithTitleAndSubtitle {
  title: ITypography;
  subtitle?: ITypography | ReactNode;
  stackProps?: SxProps;
}

function isITypography(obj: ITypography | ReactNode): obj is ITypography {
  return typeof obj === 'object' && obj !== null && 'text' in obj;
}

export const StackWithTitleAndSubtitle = ({
  title,
  subtitle,
  stackProps,
}: IStackWithTitleAndSubtitle) => {
  const isDesktop = useIsDesktop();

  const renderSubtitle = useCallback(() => {
    if (!subtitle) return;

    return isITypography(subtitle) ? (
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: '18px',
          padding: '0 25px 0 0',
          ...subtitle.typographyStyles,
        }}
        component={'h2'}
        tabIndex={0}
      >
        {subtitle.text}
      </Typography>
    ) : (
      subtitle
    );
  }, [subtitle]);

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        margin: '42px 0 0 0',
        ...stackProps,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: isDesktop ? '28px' : '24px',
          ...title.typographyStyles,
        }}
        component={'h2'}
        tabIndex={0}
      >
        {title.text}
      </Typography>
      {renderSubtitle()}
    </Stack>
  );
};
